import { render, staticRenderFns } from "./Messsage.vue?vue&type=template&id=0919bf8f&scoped=true"
import script from "./Messsage.vue?vue&type=script&lang=js"
export * from "./Messsage.vue?vue&type=script&lang=js"
import style0 from "./Messsage.vue?vue&type=style&index=0&id=0919bf8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0919bf8f",
  null
  
)

export default component.exports